// Ф6 — прогнозно-взвешенная вариабельность дневного ряда столбца (формулы прототипа v14).
// Параметры: W — окно RMSSD, T — окно тренда, L — горизонт прогноза, w — вес факта,
// up — прогноз только вверх (падение вариабельности не считаем сигналом).
export const F6DEF = { W: 7, T: 15, L: 8, w: 0.1, up: true };

// Тейл—Сен: медиана попарных наклонов (нижняя при чётном числе), устойчива к выбросам.
export function theil(a) {
  const m = a.length;
  if (m < 3) return 0;
  const sl = [];
  for (let i = 0; i < m; i++) for (let j = i + 1; j < m; j++) sl.push((a[j] - a[i]) / (j - i));
  sl.sort((x, y) => x - y);
  return sl[(sl.length - 1) >> 1];
}

// Дневной ряд x_d: доля сессий дня от ses столбца с оттоком в блоке ≤ B (накопленная
// мера) или ровно в B (простая). Без выбранного блока B — последний (nBlocks − 1), а без
// nBlocks — самый глубокий блок оттока в данных (как в headStats); для накопленной меры
// это то же самое. Нет ни того, ни другого — ряд пустой, а не молча нулевой.
// Дни без сессий входят нулями: пропуски — тоже ритм.
export function f6Series(units, block, metric, ses, nBlocks) {
  const B = block != null ? block
    : nBlocks != null ? nBlocks - 1
    : units.reduce((m, u) => Math.max(m, u.churn), -1);
  if (!units.length || B < 0) return { days: [], vals: [], B: B < 0 ? null : B, minD: 0, maxD: 0 };
  const by = new Map();
  let minD = Infinity, maxD = -Infinity;
  for (const u of units) {
    minD = Math.min(minD, u.day); maxD = Math.max(maxD, u.day);
    const hit = metric === 'cum' ? u.churn >= 0 && u.churn <= B : u.churn === B;
    if (hit) by.set(u.day, (by.get(u.day) || 0) + 1);
  }
  const days = [], vals = [];
  for (let d = minD; d <= maxD; d++) { days.push(d); vals.push(ses ? (by.get(d) || 0) / ses : 0); }
  return { days, vals, B, minD, maxD };
}

export function f6Calc(vals, p) {
  const n = vals.length, W = p.W;
  const base = Array(n).fill(null);
  for (let i = W - 1; i < n; i++) {
    let s = 0;
    for (let j = i - W + 2; j <= i; j++) { const d = vals[j] - vals[j - 1]; s += d * d; }
    base[i] = Math.sqrt(s / (W - 1));
  }
  const f6 = base.slice(), F = Array(n).fill(null);
  for (let t = 0; t < n; t++) {
    if (base[t] == null) continue;
    const a = t - p.L;
    if (a < 0 || base[a] == null) continue;
    const seg = [];
    for (let j = Math.max(0, a - p.T + 1); j <= a; j++) if (base[j] != null) seg.push(base[j]);
    if (seg.length < 3) continue;
    let sl = theil(seg);
    if (p.up) sl = Math.max(0, sl);
    const f = base[a] + p.L * sl;
    F[t] = f;
    if (f > base[t] || !p.up) f6[t] = p.w * base[t] + (1 - p.w) * f;
  }
  return { base, f6, F };
}

// Распределение по дням недели, 0 = Пн: 1970-01-01 (день 0) — четверг, отсюда +3.
// range {from, to} в днях: inw — сколько из них попало в окно ленты.
export function weekdays(units, range) {
  const tot = Array(7).fill(0), inw = Array(7).fill(0);
  for (const u of units) {
    const k = (((u.day + 3) % 7) + 7) % 7;
    tot[k]++;
    if (!range || (u.day >= range.from && u.day <= range.to)) inw[k]++;
  }
  return { tot, inw };
}
